import axios from 'axios';
import config from '../config/env-constants';

export default {
    baseUrl: `https://us-central1-elog-${config.currEnv === 'prod' ? '' : config.currEnv + '-'}app.cloudfunctions.net`,
    getCompanies(filterBy, view) {
        const url = `${this.baseUrl}/getCompanies?view=${view}`;
        return axios.post(url, { filterBy: JSON.stringify(filterBy) });
    },

    saveCompany(company, currUserId, currTimeStamp) {
        const url = `${this.baseUrl}/saveCompany`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            company: JSON.stringify(company)
        });
    },
}